var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1658,
    height: 1699,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1308 -71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2711.07 1567.93 2711.07 1572.41 2705.65 1572.41ZM1752.11 341 2528.89 341C2714.52 341 2865 491.556 2865 677.277L2865 1187.39 2804.85 1187.39 2804.85 696.775C2804.85 528.972 2668.89 392.941 2501.17 392.941L1782.66 392.941C1614.94 392.941 1478.98 528.972 1478.98 696.775L1478.98 1349.1C1478.98 1516.9 1614.94 1652.93 1782.66 1652.93L2164.55 1652.93 2164.55 1718 1752.11 1718C1566.48 1718 1416 1567.44 1416 1381.72L1416 677.277C1416 491.556 1566.48 341 1752.11 341Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.5 721.504C1638.5 636.45 1707.45 567.5 1792.5 567.5L2485.5 567.5C2570.55 567.5 2639.5 636.45 2639.5 721.504L2639.5 1337.5C2639.5 1422.55 2570.55 1491.5 2485.5 1491.5L1792.5 1491.5C1707.45 1491.5 1638.5 1422.55 1638.5 1337.5Z",
    stroke: "#F9F9F9",
    strokeWidth: 68.75,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847 910.5C1847 857.204 1879.01 814 1918.5 814 1957.99 814 1990 857.204 1990 910.5 1990 963.795 1957.99 1007 1918.5 1007 1879.01 1007 1847 963.795 1847 910.5Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350 1185.5C2350 1278.01 2255.76 1353 2139.5 1353 2023.24 1353 1929 1278.01 1929 1185.5 1929 1184.34 1929.02 1183.19 1929.05 1182.04L1969.65 1182.7C1967.58 1252.77 2041.95 1310.82 2135.76 1312.36 2229.56 1313.91 2307.29 1258.36 2309.35 1188.3 2309.38 1187.36 2309.39 1186.43 2309.39 1185.5Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308 814.864C1308 793.4 1325.4 776 1346.86 776L1404.14 776C1425.6 776 1443 793.4 1443 814.864L1443 1138.14C1443 1159.6 1425.6 1177 1404.14 1177L1346.86 1177C1325.4 1177 1308 1159.6 1308 1138.14Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2831 824.864C2831 803.4 2848.4 786 2869.86 786L2927.14 786C2948.6 786 2966 803.4 2966 824.864L2966 1149.14C2966 1170.6 2948.6 1188 2927.14 1188L2869.86 1188C2848.4 1188 2831 1170.6 2831 1149.14Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983.5 1689C1983.5 1646.2 2026.93 1611.5 2080.5 1611.5 2134.07 1611.5 2177.5 1646.2 2177.5 1689 2177.5 1731.8 2134.07 1766.5 2080.5 1766.5 2026.93 1766.5 1983.5 1731.8 1983.5 1689Z",
    stroke: "#000000",
    strokeWidth: 6.875,
    strokeMiterlimit: 8,
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2109,
    y: 201,
    width: 62.0002,
    height: 378,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.2 450 2284.79 450C2305.9 450 2323 467.105 2323 488.205L2323 563 1954 563 1954 488.205C1954 467.105 1971.1 450 1992.2 450Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2067 144C2067 103.683 2099.68 71.0002 2140 71.0002 2180.32 71.0002 2213 103.683 2213 144 2213 184.317 2180.32 217 2140 217 2099.68 217 2067 184.317 2067 144Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2289 905C2289 851.981 2321.01 809 2360.5 809 2399.99 809 2432 851.981 2432 905 2432 958.019 2399.99 1001 2360.5 1001 2321.01 1001 2289 958.019 2289 905Z",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconWhite);
export default __webpack_public_path__ + "static/media/AIIcon_white.13b7fea148a84935ba5c6f6764522de1.svg";
export { ForwardRef as ReactComponent };